import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/pro-light-svg-icons";
import permissions from "../../mocks/menuPermissions.json";
import { Button } from "react-bootstrap";
import { camelCase } from "lodash";
import authService from "../api-authorization/AuthorizeService";
const AddButton = ({ onAddClick, disabled, menu, subMenu }) => {
  var isAllowed;
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  if (menu) {
    isAllowed = subMenu
      ? permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
          "C"
        )
      : permissions[roleName]["menuItems"][menu].includes("C");
  } else {
    isAllowed = true;
  }
  return (
    isAllowed && (
      <Button onClick={onAddClick} variant="primary" disabled={disabled}>
        Add
      </Button>
      // <button
      //   type="button"
      //   className="add-icon"
      //   onClick={onAddClick}
      //   disabled={disabled}
      // >
      //   <FontAwesomeIcon icon={faPlusSquare} size="lg" />
      // </button>
    )
  );
};

export default AddButton;
